"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.incrementUsage = incrementUsage;
exports.getUsage = getUsage;
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Usage
 */

var contentConsumed = 0;
var temporaryContentMarker = 0;

/**
 * Increments the usage of our current sessin by checking if the currentTimeMs
 * has gone up by at least a second,
 *
 * @private
 * @internal
 * @param {number} currentTimeMs - The curentTimeMs value of the video
 */
function incrementUsage(currentTimeMs) {
  var time = Math.ceil(currentTimeMs);
  if (time !== temporaryContentMarker) {
    temporaryContentMarker = time;
    contentConsumed++;
  }
}

/**
 * Returns the current usage of the sessions
 */
function getUsage() {
  return contentConsumed;
}